import {Component, Inject, Input} from 'ng-metadata/core';
import {JwtUtilService} from "../../../../security/jwtUtil.service";
import {beacon, PrimolyticsService} from '../../../../analytics/primolytics.service';
import {LoginService} from '../../../../security/login/login.service';


@Component({
    "selector": "prm-service-no-offer-found",
    templateUrl: 'components/search/fullView/ngrs/noOfferFound/noOfferFound.html'
})

export class PrmServiceNoOfferFound{

    @Input() item:Object;
    @Input() opennoofferform:Object;
    @Input() private bestoffer: Object ;
    private offerFound: boolean = false;
    private _openBlankForm={openBlankForm:false};
    private _openDigitalForm={openDigitalForm:false};
    private _openPhysicalForm={openPhysicalForm:false};
    private _requestSubmitted = false;

    private _showMessageBar: {
        showMessageBar: boolean,
        borrowingRequestOK: boolean,
        message: string
    };
    
    constructor (private jwtUtilService: JwtUtilService,
        private loginService: LoginService,
        private primolyticsService: PrimolyticsService){       
    }

    ngOnInit(){
        this._showMessageBar={showMessageBar:false,
            borrowingRequestOK: false,
            message:""};
    }

    public isSignedIn(){
        return this.jwtUtilService.isSignedIn();
    } 

    @beacon({'p':'general', 'op':'signIn'})
    public signIn(){
        this.loginService.handleLoginClick();
    }

    public getShowForm(){
        return this._openBlankForm.openBlankForm;
    }

    public setShowForm(){
        if(this._openBlankForm.openBlankForm && !this.showSuceesBar() && !this.isRequestOK()){
            this._openBlankForm.openBlankForm = false;
        }else{
            this._openBlankForm.openBlankForm = true;
            this.opennoofferform.openBlankForm = true;
            this._showMessageBar.showMessageBar = false;
            this._showMessageBar.borrowingRequestOK = false;
        }
    }

    public showSuceesBar(): boolean {
        return this._showMessageBar.showMessageBar;
    }

    public getResponseMessage(): String {
        return this._showMessageBar.message ? this._showMessageBar.message : 'nui.ngrs.request.failed';
    }

    public isRequestOK(): boolean {
        return this._showMessageBar.borrowingRequestOK;
    }

    recieveSubmitEvent(event) {
        this._requestSubmitted = true;
     }   
     
     public isShowRequestSpinner(){
         return this._requestSubmitted;
     }    

}








// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/noOfferFound/noOfferFound.directive.ts